import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'src/utils/axios'
import { backend } from 'src/config'
import { REQUEST_VALUE, PARCEL_STATUSES } from 'src/constants'
import axiosInstance from 'src/utils/axios'
import { getDateWitchRightFormat } from 'src/utils/date'
import { fetchUrl } from '../fetchTableResults/thunk'

export const asyncReturnToClient = createAsyncThunk(
  'PARCEL_RETURN_TO_CLIENT',
  async ({ items }, { rejectWithValue }) => {
    try {
      const requests = items.map(async (item) => {
        await axios.put(`${backend}/api/parcel/${item.id}`, {
          statusId: 100,
        })
      })

      await Promise.all(requests)

      return REQUEST_VALUE.SUCCESS
    } catch (error) {
      console.error('Error occurred in asyncReturnToClient: ', error)
      return rejectWithValue(REQUEST_VALUE.ERROR)
    }
  }
)

export const unpackAwaitingPaymentParcel = createAsyncThunk(
  'PARCEL_UNPACK_AWAITING_PAYMENT',
  async ({ items }, { rejectWithValue }) => {
    try {
      const goodIdsPerParcel = await Promise.all(
        items.map(async (item) => {
          // Fetch goods before dismantling, in case dismantling disassociates them.
          const goodsResponse = await axios.get(
            `${backend}/api/goods/parcel/${item.id}?offset=100000`
          )
          const goods = goodsResponse?.data?.data ?? goodsResponse?.data ?? []
          const goodIds = goods.map((good) => good.id)

          const response = await axios.put(
            `${backend}/api/parcel/dismantling/${item.id}`
          )
          console.log('dismantling response', item.id, response?.data)

          return goodIds
        })
      )

      return {
        status: REQUEST_VALUE.SUCCESS,
        goodIds: goodIdsPerParcel.flat(),
      }
    } catch (error) {
      console.error('Error in unpackAwaitingPaymentParcel: ', error)
      return rejectWithValue(REQUEST_VALUE.ERROR)
    }
  }
)

export const fetchParcelById = createAsyncThunk(
  'FETCH_PARCELS',
  async ({ parcelId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${backend}/api/parcel/${parcelId}`
      )

      return response.data
    } catch (error) {
      console.error('Error in FETCH_ORDER_DETAILS', error)
      return rejectWithValue([], error)
    }
  }
)

export const fetchRegistryParcels = createAsyncThunk(
  'FETCH_REGISTRY_PARCELS',
  async (
    { filterValue, page = 1, offset = 1000, enqueueSnackbar },
    { rejectWithValue }
  ) => {
    try {
      const url = `${backend}/api/parcel/for-unitrade?page=${page}&offset=${offset}`

      const filterUrl = filterValue
        ? `${url}&parcelId=${filterValue}`
        : `${url}&from=2025-02-01 00:00:00.164`
      const response = await axiosInstance.get(filterUrl)

      const ifThereIsNotResult = !response.data?.data?.length && filterValue
      if (ifThereIsNotResult) {
        const responseByClientId = await axiosInstance.get(
          `${url}&clientId=${filterValue}`
        )
        return responseByClientId.data
      }

      return response.data
    } catch (error) {
      console.error('Error in FETCH_PARCELS', error)
      enqueueSnackbar('Мы не смогли получить посылки.', {
        variant: 'error',
      })
      return rejectWithValue(error.message) // Return error properly
    }
  }
)

// export const fetchParcels = createAsyncThunk(
//   'FETCH_PARCELS',
//   async (
//     { query, page = 1, offset = 1000, enqueueSnackbar },
//     { rejectWithValue }
//   ) => {
//     try {
//       const response = await axiosInstance.get(
//         `${backend}/api/parcel?page=${page}&offset=${offset}&${query}`
//       );

//       return response.data;
//     } catch (error) {
//       console.error('Error in FETCH_PARCELS', error);
//       enqueueSnackbar('Мы не смогли получить посылки.', {
//         variant: 'error'
//       });
//       return rejectWithValue(error.message); // Return error properly
//     }
//   }
// );

export const fetchParcelStatuses = createAsyncThunk(
  'FETCH_PARCEL_STATUSES',
  async ({ parcelId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${backend}/api/parcelStatusHistory/${parcelId}`
      )
      return response.data
    } catch (error) {
      console.error('Error in FETCH_ORDER_DETAILS', error)
      return rejectWithValue([], error)
    }
  }
)

export const putParcel = createAsyncThunk(
  'PUT_PARCEL',
  async (
    {
      parcelId,
      body,
      url,
      page,
      limit,
      enqueueSnackbar,
      successMessage = 'Посылка перемещена в архив',
      feedback = () => {},
    },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const response = await axiosInstance.put(
        `${backend}/api/parcel/${parcelId}`,
        body
      )
      feedback()
      enqueueSnackbar(successMessage, {
        variant: 'success',
        autoHideDuration: 3000,
      })
      url && dispatch(fetchUrl({ url, page, offset: limit }))
      return response.data
    } catch (error) {
      const err = error?.messageRu || 'Что-то пошло не так'
      enqueueSnackbar(err, {
        variant: 'error',
        autoHideDuration: 3000,
      })
      console.error('Error in PUT_PARCEL', error)
      return rejectWithValue([], error)
    }
  }
)

export const updateParcelStatusFromSupport = createAsyncThunk(
  'UPDATE_PARCEL_STATUS_FROM_SUPPORT',
  async (
    { parcelId, statusId, enqueueSnackbar, onSuccess = () => {} },
    { rejectWithValue }
  ) => {
    try {
      // NOTE: the backend path segment is misspelled "stataus" — keep as-is.
      const response = await axiosInstance.put(
        `${backend}/api/parcel/support/${parcelId}/stataus/${statusId}`
      )
      enqueueSnackbar('Статус посылки успешно изменён', {
        variant: 'success',
        autoHideDuration: 3000,
      })
      onSuccess()
      return response.data
    } catch (error) {
      const err =
        error?.messageRu ||
        error?.message ||
        error?.error ||
        'Не удалось изменить статус посылки'
      enqueueSnackbar(err, {
        variant: 'error',
        autoHideDuration: 3000,
      })
      console.error('Error in UPDATE_PARCEL_STATUS_FROM_SUPPORT', error)
      return rejectWithValue(error)
    }
  }
)

export const confirmParcel = createAsyncThunk(
  'CONFIRM_PARCELS',
  async ({ parcelId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${backend}/api/parcel/parcelData/confirm/${parcelId}`
      )
      return response.data
    } catch (error) {
      console.error('Error in CONFIRM_PARCELS', error)
      return rejectWithValue(error)
    }
  }
)

export const fetchParcelsByStatus = createAsyncThunk(
  'FETCH_PARCELS_BY_STATUS',
  async (
    {
      statusId,
      offset = 100000,
      page,
      enqueueSnackbar,
      id,
      clientId,
      outgoingDeclaration,
      countryId,
      deliveryTransportId,
      sortBy,
      sortDir,
    },
    { rejectWithValue }
  ) => {
    try {
      const params = { statusId, offset }
      if (page != null) params.page = page
      const rawId = id == null ? '' : String(id).trim()
      const hasIdFilter = rawId !== ''
      const parsedId = hasIdFilter ? Number(rawId) : NaN

      // If user typed a non-numeric value into "search by parcel id"
      // (e.g. DBRPST3042173171), try to resolve it as a tracking/outgoingDeclaration,
      // then re-query by the resolved numeric parcel id.
      if (hasIdFilter && !Number.isFinite(parsedId)) {
        const resolveParams = {
          statusId,
          offset: 1,
          outgoingDeclaration: rawId,
        }
        const trimmedCountryId =
          countryId == null ? '' : String(countryId).trim()
        if (trimmedCountryId !== '') resolveParams.countryId = countryId
        if (
          deliveryTransportId != null &&
          String(deliveryTransportId).trim() !== ''
        )
          resolveParams.deliveryTransportId = deliveryTransportId
        if (sortBy != null && String(sortBy).trim() !== '') {
          resolveParams.sortBy = sortBy
          resolveParams.sortDir = sortDir || 'ASC'
        }

        const resolveResponse = await axiosInstance.get(
          `${backend}/api/parcel`,
          {
            params: resolveParams,
          }
        )
        const resolveData = resolveResponse.data
        const resolvedList = Array.isArray(resolveData)
          ? resolveData
          : Array.isArray(resolveData?.data)
          ? resolveData.data
          : null
        const resolvedId = resolvedList?.[0]?.id

        const resolvedIdNumber = Number(resolvedId)
        if (!Number.isFinite(resolvedIdNumber)) {
          // Nothing resolved → return empty result with stable shape.
          if (Array.isArray(resolveData)) return []
          return {
            ...(resolveData ?? {}),
            data: [],
            totalElements: 0,
            totalPages: 1,
          }
        }

        params.id = String(resolvedIdNumber)
      } else if (hasIdFilter) {
        params.id = rawId
      }
      if (clientId != null && String(clientId).trim() !== '')
        params.clientId = clientId
      if (
        outgoingDeclaration != null &&
        String(outgoingDeclaration).trim() !== ''
      )
        params.outgoingDeclaration = outgoingDeclaration
      if (countryId != null && String(countryId).trim() !== '')
        params.countryId = countryId
      if (
        deliveryTransportId != null &&
        String(deliveryTransportId).trim() !== ''
      )
        params.deliveryTransportId = deliveryTransportId
      if (sortBy != null && String(sortBy).trim() !== '') {
        params.sortBy = sortBy
        params.sortDir = sortDir || 'ASC'
      }
      const response = await axiosInstance.get(`${backend}/api/parcel`, {
        params,
      })
      const responseData = response.data

      // Ensure "search by parcel id" is exact-match on the client side.
      // Some backends may treat id as a fuzzy/partial filter; we want strict equality.
      const responseIdParam = params.id == null ? '' : String(params.id).trim()
      if (responseIdParam === '') return responseData

      const responseIdNumber = Number(responseIdParam)
      if (!Number.isFinite(responseIdNumber)) return responseData

      if (Array.isArray(responseData)) {
        return responseData.filter((p) => Number(p?.id) === responseIdNumber)
      }

      const list = Array.isArray(responseData?.data) ? responseData.data : []
      const filtered = list.filter((p) => Number(p?.id) === responseIdNumber)
      return {
        ...(responseData ?? {}),
        data: filtered,
        totalElements: filtered.length,
        totalPages: 1,
      }
    } catch (error) {
      console.error('Error in FETCH_PARCELS_BY_STATUS', error)
      if (enqueueSnackbar) {
        enqueueSnackbar(error.message || 'Не удалось загрузить посылки.', {
          variant: 'error',
        })
      }
      return rejectWithValue(error)
    }
  }
)

export const fetchAwaitingParcels = createAsyncThunk(
  'FETCH_AWAITING_PARCELS',
  async ({ offset = 50, limit, page = 1 } = {}, { rejectWithValue }) => {
    try {
      const resolvedLimit = limit ?? offset
      const response = await axiosInstance.get(`${backend}/api/parcel`, {
        params: {
          statusId: PARCEL_STATUSES.WAITING_FOR_ARCHIVE,
          offset: resolvedLimit,
          page,
        },
      })
      return response.data
    } catch (error) {
      console.error('Error in FETCH_AWAITING_PARCELS', error)
      return rejectWithValue(error)
    }
  }
)

export const fetchAwaitingParcelById = createAsyncThunk(
  'FETCH_AWAITING_PARCEL_BY_ID',
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${backend}/api/parcel`, {
        params: {
          statusId: PARCEL_STATUSES.WAITING_FOR_ARCHIVE,
          id,
        },
      })
      // The generic endpoint filters by id fuzzily, so match exactly here.
      const list = response.data?.data ?? []
      const match = list.find((parcel) => Number(parcel?.id) === Number(id))
      return match || {}
    } catch (error) {
      console.error('Error in FETCH_AWAITING_PARCEL_BY_ID', error)
      return rejectWithValue(error)
    }
  }
)

export const updateParcel = createAsyncThunk(
  'UPDATE_PARCEL',
  async ({ parcelId, body = {} }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${backend}/api/parcel/${parcelId}`,
        {
          ...body,
        }
      )
      return { id: parcelId, data: response.data }
    } catch (error) {
      console.error('Error in UPDATE_PARCEL', error)
      return rejectWithValue(error)
    }
  }
)

export const fetchParcelByNumber = createAsyncThunk(
  'FETCH_PARCEL_BY_NUMBER',
  async ({ trackCode }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${backend}/api/parcel/trackCode?trackCode=${trackCode}`
      )
      return response.data
    } catch (error) {
      console.error('Error in FETCH_PARCEL_BY_NUMBER', error)
      return rejectWithValue(error)
    }
  }
)

export const createBag = createAsyncThunk(
  'CREATE_BAG',
  async ({ createSubmitValues }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${backend}/api/bag`,
        createSubmitValues
      )

      return response.data
    } catch (error) {
      console.error('Error in CREATE_BAG', error)
      return rejectWithValue(error)
    }
  }
)

export const createShipmentBag = createAsyncThunk(
  'CREATE_SHIPMENT_BAG',
  async ({ createSubmitValues }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${backend}/api/bag/shipment`,
        createSubmitValues
      )
      return response.data
    } catch (error) {
      console.error('Error in CREATE_SHIPMENT_BAG', error)
      return rejectWithValue(error)
    }
  }
)

export const fetchAllBags = createAsyncThunk(
  'FETCH_ALL_BAGS',
  async (
    { offset, page, sealNumber, name, statusId, type, lastMileOperatorId },
    { rejectWithValue }
  ) => {
    try {
      const params = { page: page + 1, offset }
      if (sealNumber) params.sealNumber = sealNumber
      if (name) params.name = name
      if (statusId) params.statusId = statusId
      if (type) params.type = type
      if (lastMileOperatorId) params.lastMileOperatorId = lastMileOperatorId

      const response = await axiosInstance.get(`${backend}/api/bag`, {
        params,
      })
      return response.data
    } catch (error) {
      console.error('Error in FETCH_ALL_BAGS', error)
      return rejectWithValue(error)
    }
  }
)

export const fetchBagById = createAsyncThunk(
  'FETCH_BAG_BY_ID',
  async ({ bagId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${backend}/api/bag/${bagId}`)
      return response.data
    } catch (error) {
      console.error('Error in FETCH_BAG_BY_ID', error)
      return rejectWithValue(error)
    }
  }
)

export const updateBag = createAsyncThunk(
  'UPDATE_BAG',
  async ({ bagId, body }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${backend}/api/bag/${bagId}`,
        body
      )

      return response.data
    } catch (error) {
      console.error('Error in UPDATE_BAG', error)
      return rejectWithValue(error)
    }
  }
)

export const addParcelToBagEdit = createAsyncThunk(
  'HANDLE_ADD_PARCEL_TO_BAG',
  async ({ bagId, parcelId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${backend}/api/bag/${bagId}/parcel/${parcelId}`
      )

      return response.data
    } catch (error) {
      console.error('Error in UPDATE_BAG', error)
      return rejectWithValue(error)
    }
  }
)

export const removeParcelFromBagAsync = createAsyncThunk(
  'REMOVE_PARCEL_FROM_BAG_ASYNC',
  async (parcelId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(
        `${backend}/api/bag/parcel/${parcelId}`
      )
      return response.data
    } catch (error) {
      console.error('Error in REMOVE_PARCEL_FROM_BAG', error)
      return rejectWithValue(error)
    }
  }
)

export const removeShipmentFromBagAsync = createAsyncThunk(
  'REMOVE_SHIPMENT_FROM_BAG_ASYNC',
  async (shipmentId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(
        `${backend}/api/bag/shipment/${shipmentId}`
      )
      return response.data
    } catch (error) {
      console.error('Error in REMOVE_SHIPMENT_FROM_BAG_ASYNC', error)
      return rejectWithValue(error)
    }
  }
)

export const fetchAllSendingRegistry = createAsyncThunk(
  'FETCH_ALL_SENDING_REGISTRY',
  async ({ offset, page, sendingRegisterNumber }, { rejectWithValue }) => {
    try {
      const params = { page: page + 1, offset }

      if (sendingRegisterNumber) {
        params.sendingRegisterNumber = sendingRegisterNumber
      }

      const response = await axiosInstance.get(
        `${backend}/api/sending-registry`,
        {
          params,
        }
      )
      return response.data
    } catch (error) {
      console.error('Error in REMOVE_PARCEL_FROM_BAG', error)
      return rejectWithValue(error)
    }
  }
)

export const createParcelRegistry = createAsyncThunk(
  'CREATE_PARCEL_REGISTRY',
  async ({ body }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${backend}/api/sending-registry`,
        body
      )

      return response.data
    } catch (error) {
      console.error('Error in CREATE_PARCEL_REGISTRY', error)
      return rejectWithValue(error)
    }
  }
)

export const fetchParcelRegistryById = createAsyncThunk(
  'FETCH_PARCEL_REGISTRY_BY_ID',
  async ({ registryId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${backend}/api/sending-registry/${registryId}`
      )
      return response.data
    } catch (error) {
      console.error('Error in FETCH_PARCEL_REGISTRY_BY_ID', error)
      return rejectWithValue(error)
    }
  }
)

export const deleteSendingRegistry = createAsyncThunk(
  'DELETE_SENDING_REGISTRY',
  async (
    { registryId, enqueueSnackbar, suppressSuccessSnackbar = false },
    { rejectWithValue }
  ) => {
    try {
      await axiosInstance.delete(
        `${backend}/api/sending-registry/${registryId}`
      )
      if (!suppressSuccessSnackbar) {
        enqueueSnackbar?.('Реестр успешно удалён', { variant: 'success' })
      }
      return registryId
    } catch (error) {
      console.error('Error in DELETE_SENDING_REGISTRY', error)
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        'Не удалось удалить реестр'
      enqueueSnackbar?.(msg, { variant: 'error' })
      return rejectWithValue(error)
    }
  }
)

export const deleteBagsFromParcelRegistry = createAsyncThunk(
  'DELETE_BAGS_FROM_PARCEL_REGISTRY_ASYNC',
  async ({ registryId, bagId }, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(
        `${backend}/api/sending-registry/parcelBag/${registryId}?parcelBagId=${bagId}`
      )
      return REQUEST_VALUE.SUCCESS
    } catch (error) {
      console.error('Error occurred in deleteBagsFromParcelRegistry: ', error)
      return rejectWithValue(REQUEST_VALUE.ERROR)
    }
  }
)

export const updateSendingRegistry = createAsyncThunk(
  'UPDATE_SENDING_REGISTRY',
  async ({ registryId, body }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${backend}/api/sending-registry/${registryId}`,
        body
      )
      return response.data
    } catch (error) {
      console.error('Error in UPDATE_SENDING_REGISTRY', error)
      return rejectWithValue(error)
    }
  }
)

export const fetchRegistryByNumber = createAsyncThunk(
  'FETCH_REGISTRY_BY_NAME',
  async ({ number }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${backend}/api/sending-registry?sendingRegisterNumber=${number}`
      )
      return response.data
    } catch (error) {
      console.error('Error in FETCH_REGISTRY_BY_NAME', error)
      return rejectWithValue(error)
    }
  }
)

export const fetchDeliveryTransports = createAsyncThunk(
  'FETCH_DELIVERY_TRANSPORTS',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${backend}/api/delivery-transport`
      )
      return response.data
    } catch (error) {
      console.error('Error in FETCH_DELIVERY_TRANSPORTS', error)
      return rejectWithValue(error)
    }
  }
)

export const fetchShipmentManager = createAsyncThunk(
  'FETCH_SHIPMENT_MANAGER',
  async (
    {
      incomingDeclaration,
      registeredInUnitrade,
      dpTrackNumber,
      limit,
      page = 1,
      statusId,
      statusIds,
    } = {},
    { rejectWithValue }
  ) => {
    try {
      const params = {}
      if (limit != null) {
        params.offset = limit
      }
      if (page != null) {
        params.page = page
      }
      if (statusId != null) {
        params.statusId = statusId
      }
      if (statusIds != null) {
        params.statusIds = statusIds
      }
      if (incomingDeclaration) {
        params.incomingDeclaration = incomingDeclaration
      }
      if (dpTrackNumber) {
        params.dpTrackNumber = dpTrackNumber
      }
      if (registeredInUnitrade !== undefined && registeredInUnitrade !== null) {
        params.registeredInUnitrade = registeredInUnitrade
      }
      const acceptTime = getDateWitchRightFormat(0)
      if (acceptTime && (incomingDeclaration || dpTrackNumber)) {
        params.acceptTime = acceptTime
      }
      const response = await axiosInstance.get(
        `${backend}/api/manager/shipment?version=v2`,
        { params }
      )
      return response.data
    } catch (error) {
      console.error('Error in FETCH_SHIPMENT_MANAGER', error)
      return rejectWithValue(error)
    }
  }
)

export const editShipmentBagAsync = createAsyncThunk(
  'EDIT_SHIPMENT_BAG',
  async ({ bagId, shipmentId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${backend}/api/bag/${bagId}/shipment/${shipmentId}`
      )
      return response.data
    } catch (error) {
      console.error('Error in EDIT_SHIPMENT_BAG', error)
      return rejectWithValue(error)
    }
  }
)

export const updateShipment = createAsyncThunk(
  'UPDATE_SHIPMENT',
  async ({ body, shipmentId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${backend}/api/manager/shipment/${shipmentId}`,
        body
      )
      return response.data
    } catch (error) {
      console.error('Error in EDIT_SHIPMENT', error)
      return rejectWithValue(error)
    }
  }
)

export const fetchShipmentTariffs = createAsyncThunk(
  'FETCH_SHIPMENT_TARIFFS',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${backend}/api/manager/shipment/delivery-tariff`
      )
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const updateBagStatus = createAsyncThunk(
  'UPDATE_BAG_STATUS',
  async ({ bagId, statusId, snackBar = () => {} }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${backend}/api/bag/${bagId}/status/${statusId}`
      )
      snackBar(`Статус мешка ${bagId} изменен`, { variant: 'success' })
      return response.data
    } catch (error) {
      const err = error?.message || 'Что-то пошло не так'
      snackBar(err, { variant: 'error' })
      return rejectWithValue(error)
    }
  }
)

export const asyncReturnManyGoodsToClient = createAsyncThunk(
  'PARCEL_RETURN_MANY_GOODS_TO_CLIENT',
  async ({ parcelId }, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(
        `${backend}/api/parcel/awaiting-payment/understaff/${parcelId}`
      )
      return REQUEST_VALUE.SUCCESS
    } catch (error) {
      console.error('Error in asyncReturnManyGoodsToClient:', error)
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        'Неизвестная ошибка'
      return rejectWithValue(message)
    }
  }
)
